import color from './properties/color';
import fontFamily from './properties/fontFamily';
import numeric from './properties/numeric';
import other from './properties/other';
import select from './properties/select';
import switcher from './properties/switcher';
export default {
  ...color,
  ...fontFamily,
  ...numeric,
  ...other,
  ...select,
  ...switcher
}